import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import { UserDb } from '../redux/userDbSlice';

const useCurrentUserDb = () : [string | undefined, UserDb | undefined] => {
  const userDb = useSelector((state: RootState) => state.userDb);
  if (userDb.currentUserId) {
    const userId = userDb.currentUserId;
    const userValue = userDb.users[userId];
    return [userId, userValue];
  } else {
    return [undefined, undefined];
  }
}

export default useCurrentUserDb;
